import api, { ValidateAxiosError, ValidateAxiosErrorSemRedirecionar } from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';
import { ReadEstagiarioDto, ReadEstagiarioSelectDto } from '@/api.types';
import { FindEstagiarioDto } from '@/api.types.extra';
import { isAxiosError } from 'axios';

const endpoint = Endpoints.ESTAGIARIO;

export async function readEstagiario(filters: FindEstagiarioDto) {
  if (filters) {
    filters.skip ??= 0;
    filters.take ??= 10;
  }

  try {
    const response = await api.get<[ReadEstagiarioDto[], number]>(endpoint, { params: filters });
    return response.data;
  } catch (error) {
    if (isAxiosError(error) && error.response?.status === 401) {
      throw ValidateAxiosErrorSemRedirecionar(error, 'Falha ao buscar estagiário(s).');
    }
    throw ValidateAxiosError(error, 'Falha ao buscar estagiário(s).');
  }
}

export async function readEstagiarioFroTransparency(filters: FindEstagiarioDto) {
  if (filters) {
    filters.skip ??= 0;
    filters.take ??= 10;
  }

  try {
    const response = await api.get<[ReadEstagiarioDto[], number]>(`${endpoint}/transparency/trainee`, { params: filters });
    return response.data;
  } catch (error) {
    if (isAxiosError(error) && error.response?.status === 401) {
      throw ValidateAxiosErrorSemRedirecionar(error, 'Falha ao buscar estagiário(s).');
    }
    throw ValidateAxiosError(error, 'Falha ao buscar estagiário(s).');
  }
}

export async function readEstagiarioForAttendanceSheetSelect() {
  try {
    const response = await api.get<[ReadEstagiarioSelectDto[], number]>(`${endpoint}/select`);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao buscar estagiário(s).');
  }
}